export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8693.2f5f6d1c.jpg";